<audit-notice-display [audit]="audit" [kit]="activeKit"></audit-notice-display>
<table>
    <tbody *ngFor="let item of sortedItems; let idx = index" class="audit-item">
        <tr *ngIf="idx>0 && item.checked && !sortedItems[idx-1].checked">
            <td colspan="3"><hr /></td>
        </tr>
        <tr>
            <td>
                <button mat-mini-fab (click)="toggleAuditCheck(item)" class="audit-checkbox"
                    [style.color]="LifeCycleContrastColor(item.LifeCycle)"
                    [style.backgroundColor]="LifeCycleColor(item.LifeCycle)">
                    <mat-icon>{{item.checked ? 'checkmark' : ''}}</mat-icon>
                </button>
            </td>
            <td class="inventory-id"><span (click)="toggleAuditCheck(item)">{{item.InventoryID}}</span></td>
            <td class="item-description"><span (click)="toggleAuditCheck(item)">{{item.Description}}</span></td>
        </tr>
    </tbody>
</table>